import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ThemePicker from '../../components/ThemePicker';

export default function AdminAppearance() {
  return (
    <AdminLayout title="Appearance">
      <div className="admin-table-wrap" style={{ padding: 20, maxWidth: 420 }}>
        <p style={{ margin: '0 0 20px', fontSize: 13, color: 'var(--text3)' }}>
          Choose how your admin console looks. This is a personal preference and only affects your own account.
        </p>
        <ThemePicker scope="admin" />
      </div>
    </AdminLayout>
  );
}
